import { Link } from 'react-router-dom';
import { Seo } from '../components/seo';

function SuccessResetPasswordPage() {
  return (
    <>
      <Seo title="Reset Password Success" />
      <div className="min-h-screen w-full flex flex-col justify-center">
        <div className="p-12 mx-auto shadow-lg rounded-2xl">
          <h1 className="text-5xl font-bold text-center">Password has been succsessfully reset!</h1>
          <hr />
          <div className="mt-8">
            <Link className="text-center text-blue hover:text-darkblue" to="/login">Login</Link>
          </div>
        </div>
      </div>
    </>
  );
}

export default SuccessResetPasswordPage;
